const lineHeight = 36;
const rowHeight = 48;

export default {
  pagination: {
    numberToDisplayPerPage: 30,
  },
  table: {
    rowHeight,
    headerHeight: lineHeight,
    footerHeight: lineHeight,
    maxLineToDisplay: 15,
  },
};
